import React from 'react';
import SentenceForm from "../../components/common/SentenceForm";
import Container from "@material-ui/core/Container";
import TextField from "@material-ui/core/TextField";
import {makeStyles} from "@material-ui/core";
import ScrollableAnchor from "react-scrollable-anchor";
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {answerState, menuCheckSelector, selectedMenuItemState, surveyDataState} from "../../state/globalState";

/**
 * 설문 문항 컴포넌트
 */
const Survey3 = (props) => {
    const surveyData = useRecoilValue(surveyDataState);
    const [answer, setAnswer] = useRecoilState(answerState);
    const setSelectedMenuItem = useSetRecoilState(selectedMenuItemState);
    const setMenuCheck = useSetRecoilState(menuCheckSelector);
    let parentCompRef = props.compRef;

    const handleInputAnswer = (e, column) => {
        const { value } = e.target;
        const onlyNums = value.replace(/[^0-9]/g, '');

        if (onlyNums.length < 20) {
            const newState = {
                ...answer,
                [column]: onlyNums
            }
            setAnswer(newState)

            setSelectedMenuItem('SURVEY_10');
            setMenuCheck(value !== '');
        }
    };

    const addRefs = (e) => {
        parentCompRef[10] = e;
    };

    return (
        <>
            <ScrollableAnchor id={"10"}>
                <div>
                <Container style={{background: 'transparent', marginBottom: '10px'}}>
                    <SentenceForm
                        title={surveyData[10].title}
                        sentences={surveyData[10].questions}
                        step={10}
                    />
                    <div className="textFieldContainer">
                        <TextField
                            // id={step + '-1'}
                            label="여기에 답변을 입력하십시오."
                            placeholder=""
                            margin="none"
                            value={answer.telNo}
                            onChange={(e) => handleInputAnswer(e, 'telNo')}
                            inputRef={addRefs}
                        />
                    </div>
                </Container>
                </div>
            </ScrollableAnchor>
        </>
    );
};

export default Survey3;
